<script>
import formatCurrency from "@utils/format-currency";
import formatPaymentMethod from "@utils/format-payment-method";
import  { formatOrder } from "@utils/format-order";
import { authComputed, merchantComputed } from "@store/helpers";
import formatPrice from "@utils/format-price";
import { conditionList } from "@utils/is-condition";
import { 
  orderAtmInfoList, 
  orderIsCanPay,
  // orderIsOffline,
  orderIsUseDeduct,
  orderVaccInfoList,
  orderIsPrepaidUnpaidAndDeduct,
  orderBillingReserveList,
  orderReserveParamsList,
} from "@utils/ipetbooking-order";

export default {
  components: {
    Detail: () =>  import("@components/Order/OrderReservationList"),
    OrderPaymentButton: () => import("@components/Order/OrderPaymentButton"),
  },
  props: {
    orderItem: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      activeTab: 'detail',
    }
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    
    // hasExtrafieldsByOrder() {
    //   const orderExtrafields = this.orderItem.byOrderExtrafields || {};

    //   return !!Object.keys(orderExtrafields)[0];
    // },
    // hasExtrafields() {
    //   return this.hasExtrafieldsByOrder
    // },
    // isOffline() {
    //   return orderIsOffline({
    //     order: this.orderItem,
    //     ordertype: 'order',
    //     type: 'reservation'
    //   });
    // },
    isUseDeduct() {
      return orderIsUseDeduct({ ...this.orderItem })
    },
    isUnpaidAndDeduct() {
      return orderIsPrepaidUnpaidAndDeduct({ ...this.orderItem })
    },
    priceTotal() {
      const ordersListTotal = this.orderItem.orders.items.reduce((previousValue, currentValue) => {
        return previousValue + currentValue.priceTotal
      }, 0);
      const paramsListTotal = this.orderItem.params.reduce((previousValue, currentValue) => {
        return previousValue + currentValue.total
      }, 0);
      return ordersListTotal + paramsListTotal
    },
    // orderBillingParamsList() {
    //   const paramsList = (typeList) => {
    //     return orderReserveParamsList({
    //       typeList,
    //       params: this.orderItem.params,
    //     });
    //   };
    //   const total = this.orderItem.orders.items.reduce((previousValue, currentValue) => {
    //     return previousValue + currentValue.priceTotal
    //   }, 0);
    //   return conditionList([
    //     {
    //       title: '小計',
    //       text: `${formatPrice(total)}`,
    //       textClass: 'font-number',
    //     },
    //     {
    //       type: 'hr',
    //       condition: () => {
    //         return !!paramsList(['+', '-', '%'])[0]
    //       },
    //     },
    //     ...paramsList(['+', '-', '%']),
    //   ])
    // },
    // orderBillingTotal() {
    //   const orderStatus = formatOrder(this.containerItem)
    //   return conditionList([
    //     {
    //       title: `<span class="text-${orderStatus.color} fw-semi-bold">付款金額</span><br><span class="text-gray-2 fs-2sm">${orderStatus.paidInfo}</span>`,
    //       text: `${formatPrice(this.priceTotal)}`,
    //       class: 'align-items-end mt-2',
    //       textClass: `font-number fs-xl fw-semi-bold text-${orderStatus.infoColor}`,
    //       // condition: () => {
    //       //   return type === 'order'
    //       // },
    //     }
    //   ])
    // },
    vaccInfoList() {
      return orderVaccInfoList({ ...this.orderItem, unpaid: this.priceTotal })
    },
    atmInfoList() {
      return orderAtmInfoList({ ...this.orderItem, unpaid: this.priceTotal })
    },
    specialOrderType(){
      if('type' in this.orderItem && this.orderItem.type === 'deposit'){
        return 'deposit'
      }
      return 'reservation'
    }
  },
  created() {
    // if(this.$route.query.activeTab) {
    //   this.activeTab = this.$route.query.activeTab
    // }
  },
  mounted(){
    console.log('DetailOrderItemReservation.Jtails.vue')
    console.log(this.orderItem)
  },
  methods: {
    formatCurrency,
    formatPaymentMethod,
    orderIsCanPay,
    formatPrice,
    formatOrder,
    // orderBillingList(item) {
    //   return orderBillingReserveList({
    //     type: 'order',
    //     ...item,
    //     isUnpaidAndDeduct: this.isUnpaidAndDeduct,
    //     formatOrder: formatOrder(item)
    //   });
    // },
    // goToGoogleCalendar(orderItem) {
    //   // dates   時間格式為 YYYYMMDDTHHMMSS
    //   // details 使用 %0A 作為跳行
    //   const text = `[${this.currentMerchant.title}${orderItem.param.store.title}] ${orderItem.pet.name} - ${orderItem.param.title}` || '';
    //   const start = orderItem.startDate
    //     .replace(/-/g, '')
    //     .replace(/:/g, '')
    //     .replace(/\s/g, 'T');
    //   const end = orderItem.endDate
    //     .replace(/-/g, '')
    //     .replace(/:/g, '')
    //     .replace(/\s/g, 'T');
    //   const dates = `${start}/${end}`;
    //   const details = orderItem.param.description || '';
    //   const location = orderItem.param.store.fullAddress;
    //   const query = `action=TEMPLATE&text=${text}&dates=${dates}&details=${details}&location=${location}&trp=false`;

    //   return `http://www.google.com/calendar/event?${query}`
    // },
    // goToMemberReservationItem(orderItem) {
    //   const loggedInFn = () => {
    //     this.$nextTick(() => {
    //       this.$router.push({
    //         name: 'member-reservation-item',
    //         params: {
    //           orderId: orderItem.id
    //         }
    //       })
    //     })
    //   };

    //   if(this.isLoggedIn) {
    //     loggedInFn()
    //   } else {
    //     this.$globalDialog('DialogLogin', {
    //       callbackLogin: () => {
    //         loggedInFn()
    //       }
    //     })
    //   }
    // },
    // goToMemberReservationItemChildren(orderItem) {
    //   const loggedInFn = () => {
    //     this.$nextTick(() => {
    //       this.$router.push({
    //         name: 'member-reservation-item',
    //         params: {
    //           orderId: orderItem.parentId
    //         },
    //         query: {
    //           activeTab: 'children'
    //         }
    //       })
    //     });
    //   };

    //   if(this.isLoggedIn) {
    //     loggedInFn()
    //   } else {
    //     this.$globalDialog('DialogLogin', {
    //       callbackLogin: () => {
    //         loggedInFn()
    //       }
    //     })
    //   }
    // },
    // openDialogContact(item) {
    //   this.$globalDialog('DialogContact', {
    //     storeList: [item.param.store]
    //   });
    // },
  }
}
</script>
<!-- section template -->
<template>
  <div :class="$style.detailOrderItemReservation">
  <div class="text-center mb-4">
    <span :class="`text-${formatOrder(orderItem).color}`">
      {{formatOrder(orderItem).title }}
    </span>
    <br>
    <span class="text-gray-2 fs-sm">
      {{ formatOrder(orderItem).paidInfo }}
    </span>
  </div>
  <Detail :container-item="orderItem"/>
    <!-- <div class="">
      <hr>
      <BaseList
        :data-list="orderBillingParamsList"
        class="px-md-4 px-2"
        type="order"
      />
      <hr class="detailOrderItemReservation__hr">
      <BaseList
        :data-list="orderBillingTotal"
        class="px-md-4 px-2"
        type="order"
      />
    </div> -->
    <template
      v-if="(orderItem.paymentMethod === 'Vacc' || (orderItem.prepaid && item.prepaid.paymentMethod === 'Vacc')) && !!vaccInfoList[0]">
      <hr>
      <BaseList
        :data-list="vaccInfoList"
        class="px-md-4 px-2"
        type="info"
      />
    </template>
    <template
      v-if="(orderItem.paymentMethod === 'Atm' || (orderItem.prepaid && item.prepaid.paymentMethod === 'Atm')) && !!atmInfoList[0]">
      <hr>
      <BaseList
        :data-list="atmInfoList"
        class="px-md-4 px-2"
        type="info"
      />
    </template>
    <template v-if="isUseDeduct">
      <OrderPaymentButton
        :order-item="orderItem"
        type="deduct"
        button-class="mt-5"
      />
    </template>
    <template v-else>
      <OrderPaymentButton
        :order-item="orderItem"
        :type="specialOrderType"
        button-class="mt-5"
      />
    </template>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
// .detailOrderItemReservation {
//   padding: 1.875rem;
//   border: 1px solid rgba($color-primary, 0.5);

//   @include max-md {
//     padding: 1rem;
//   }

//   :global {
//     .detailOrderItemReservation {
//       &__no {
//         padding: 1rem;
//         margin-bottom: 2rem;
//         font-size: 0.875rem;
//         background: rgba($color-blue, 0.3);
//         // border: 1px solid $color-primary;
//       }
//       &__list {
//         &:not(:last-child) {
//           margin-bottom: 1.875rem;
//         }
//       }
//       &__hr {
//         width: 100%;
//         border-top: 1px dashed $color-line;
//       }
//       &__detailBoxInner {
//         padding: 1.5rem 1rem 0;
//         display: flex;
//         @include max-md {
//           display: block;
//         }

//         &:not(:last-child) {
//           border-bottom: 1px solid $color-line;
//         }
//       }
//       &__btn {
//         &:not(:last-child) {
//           margin-right: 1rem;
//         }
//       }
//     }
//   }
// }
</style>
